module.exports = __webpack_public_path__ + "static/media/ps_max_slogan.acbce15d.svg";